/**
 * Search API — Ported from generalDataService.js
 *
 * Provides search-related API functions used by the SearchWidget.
 */

import { axiosClient } from '@/lib/axiosClient';
import { buildApiBase } from '@/lib/buildApiBase';

const API_BASE = buildApiBase();

/**
 * Get work order info by order number.
 * Matches: generalDataService.getWorkOrderInfo(orderNumber)
 */
export async function getWorkOrderInfo(orderNumber: string | number) {
  const response = await axiosClient.get(`${API_BASE}/API/WorkOrderInfo/`, {
    params: {
      orderNumber,
      includeWorkflowStateTransition: true,
    },
  });
  return response.data;
}

/**
 * Get work order info by parent submission id (WDS SUBMISSION/ORDERREQUEST branch).
 * Matches: generalDataService.getWorkOrderInfoFromSubmissionId(parentSubmissionId)
 */
export async function getWorkOrderInfoFromSubmissionId(parentSubmissionId: string | number) {
  const response = await axiosClient.get(`${API_BASE}/API/Submission/GetWorkOrder`, {
    params: {
      parentSubmissionId,
      includeWorkflowStateTransition: true,
    },
  });
  return response.data;
}

/**
 * Get work orders by SPI Property ID.
 * Matches: generalDataService.getWorkordersBySpiPropId(spiPropertyId)
 */
export async function getWorkordersBySpiPropId(spiPropertyId: number | string) {
  const response = await axiosClient.get(
    `${API_BASE}/API/WorkOrderInfo/GetWorkOrderListForProperty/`,
    {
      params: {
        spiPropertyId,
        includeWorkflowStateTransition: true,
      },
    }
  );
  return response.data;
}

/**
 * Get property info by loan number.
 * Matches: generalDataService.getPropInfoByLoanNumber(loanNumber)
 */
export async function getPropInfoByLoanNumber(loanNumber: string | number) {
  const response = await axiosClient.get(`${API_BASE}/API/PropInfo/GetPropertyLoanByLoanNum/`, {
    params: { loanNumber },
  });
  return response.data;
}

/**
 * Get property info by SPI Property ID.
 * Matches: generalDataService.getPropInfoBySpiPropId(spiPropertyId)
 */
export async function getPropInfoBySpiPropId(spiPropertyId: string | number) {
  const response = await axiosClient.get(`${API_BASE}/API/PropInfo/GetPropertyLoanByPropId/`, {
    params: { spiPropertyId },
  });
  return response.data;
}

/**
 * Get property info by Property Loan ID.
 * Matches: generalDataService.getPropInfoByPropertyLoanId(propertyLoanId)
 *          (public/SPIGlassApp/services/generalDataService.js:160)
 */
export async function getPropInfoByPropertyLoanId(propertyLoanId: string | number) {
  const response = await axiosClient.get(`${API_BASE}/API/PropInfo/GetPropertyLoanFromLoanId`, {
    params: { propertyLoanId },
  });
  return response.data;
}
